import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { NavigateActions, ValidationActions } from '../../redux/actions';
import { polyglot } from '../../assets/locales';
import ROUTES from '../../constants/RouteConstants';
import RentIncreaseInformation from './RentIncreaseInformation';
import ValidationSummary from './ValidationSummary';
import ValidationErrors from './ValidationErrors';
import ValidationComplete from './ValidationComplete';

const Validator = (props) => {
  const { cpiConfig } = props;
  const [validationDataSubmitted, setIsSubmitted] = useState(false); 
  const [validationData, setValidationData] = useState({});
  const isTenantRoute = props?.location?.pathname === ROUTES.TENANT_VALIDATOR;

  useEffect(() => {
    if (JSON.stringify(validationData) === '{}' && Object.keys(props?.validationData || {})?.length) {
      setIsSubmitted(true);
      setValidationData(props.validationData);
    }
  },[]);

  useEffect(() => {
    props.setValidationData(validationData);
  },[validationData, props])

  return (
    <div className="validator">
      <div className="hide-print">
        <p className="validator__header">Phase 1 Additional Rent Increase Validation</p>
        <p className="validator__description" dangerouslySetInnerHTML={{ __html: polyglot.t(isTenantRoute ? 'validator.tenantDescription' : 'validator.landlordDescription', {firstYearDate: '2021', year: '2021' }) }}></p>
        <span className="w1-step-one__description-warning">&nbsp;{polyglot.t('noticeGenerator.sectionOne.descriptionWarning')}</span>
      </div>
      <div className="w1-step-one">
        <p className="w1-step-one__address__label">Please provide the address of the rental unit for this rent increase<span className="w1-step-one__address__label--print show-print">:&nbsp;{validationData?.streetAddress}</span></p>
        <RentIncreaseInformation 
          validationData={validationData}
          disabled={validationDataSubmitted}
          cpiConfig={cpiConfig}
          minDecisionDate={cpiConfig.min_decision_date}
          setIsSubmitted={setIsSubmitted}
          setValidationData={setValidationData}
        />
        { validationDataSubmitted && validationData?.calcCPIValue  ?
          <>
            <ValidationSummary validationData={validationData} isTenantRoute={isTenantRoute}/>
            <ValidationErrors validationData={validationData} isTenantRoute={isTenantRoute}/>
            <ValidationComplete validationData={validationData} setValidationData={props.setValidationData} isTenantRoute={isTenantRoute} navigate={props.navigate}/>
          </>
        : null }

        { validationDataSubmitted && !validationData?.calcCPIValue ? 
          <>
            <div className="validator__errors__error alert-error">
              <b>CPI not available.</b> There is no CPI avaialable for the selected year.
            </div>
          </>
        : null }
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    cpiConfig: state.config.cpiConfig,
    validationData: state.validations.data,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      navigate: NavigateActions.navigate,
      setValidationData: ValidationActions.setValidationData
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Validator);